const permissionAction = {
    BACKUP : 'backup',

    DISCARD : 'discard',

    SAVE : 'save'

};

angular.module('gw-um-j2js')
    .constant('permissionAction', permissionAction);